import { render, staticRenderFns } from "./BidderForm.vue?vue&type=template&id=4a99ac4e&"
import script from "./BidderForm.vue?vue&type=script&lang=js&"
export * from "./BidderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a99ac4e')) {
      api.createRecord('4a99ac4e', component.options)
    } else {
      api.reload('4a99ac4e', component.options)
    }
    module.hot.accept("./BidderForm.vue?vue&type=template&id=4a99ac4e&", function () {
      api.rerender('4a99ac4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/components/BidderForm.vue"
export default component.exports